import React from 'react';

interface RatingStarsProps {
  height?: string | number;
}

const RatingStars = ({ height = 19 }: RatingStarsProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 250 45" fill="none">
    <g id="Stars">
      <path fillRule="evenodd" clipRule="evenodd" d="M22.0587 33.088L9.09291 39.9045L11.5692 25.4669L1.07963 15.2422L15.5758 13.1358L22.0587 0L28.5416 13.1358L43.0377 15.2422L32.5482 25.4669L35.0244 39.9045L22.0587 33.088Z" fill="#E7B556" />
      <path fillRule="evenodd" clipRule="evenodd" d="M73.5313 33.088L60.5656 39.9045L63.0418 25.4669L52.5523 15.2422L67.0485 13.1358L73.5313 0L80.0142 13.1358L94.5104 15.2422L84.0209 25.4669L86.4971 39.9045L73.5313 33.088Z" fill="#E7B556" />
      <path fillRule="evenodd" clipRule="evenodd" d="M125 33.088L112.034 39.9045L114.511 25.4669L104.021 15.2422L118.517 13.1358L125 0L131.483 13.1358L145.979 15.2422L135.49 25.4669L137.966 39.9045L125 33.088Z" fill="#E7B556" />
      <path fillRule="evenodd" clipRule="evenodd" d="M176.469 33.088L163.503 39.9045L165.979 25.4669L155.49 15.2422L169.986 13.1358L176.469 0L182.952 13.1358L197.448 15.2422L186.958 25.4669L189.435 39.9045L176.469 33.088Z" fill="#E7B556" />
      <path fillRule="evenodd" clipRule="evenodd" d="M227.941 33.088L214.976 39.9045L217.452 25.4669L206.962 15.2422L221.459 13.1358L227.941 0L234.424 13.1358L248.921 15.2422L238.431 25.4669L240.907 39.9045L227.941 33.088Z" fill="#E7B556" />
    </g>
  </svg>
)

export default RatingStars;
